import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ForgetpasswordComponent } from './forgetpassword.component';
import { SharedModule } from 'src/app/shared/shared.module';


@NgModule({
  declarations: [ ForgetpasswordComponent],
  providers: [
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    HttpClientModule,
    SharedModule,
  ]
  ,exports: [
    ForgetpasswordComponent
  ]
})
export class ForgetPaswordModule { }
